/*
 * @Author: WUJUN
 * @Date: 2019-10-31 17:19:55
 * @LastEditTime: 2021-10-11 17:33:32
 * @LastEditors: Please set LastEditors
 * @Description: 自定义弹框
 */
import Vue from 'vue';
// import login from './login';
import toogle from './toogle';
import freeze from './freeze';
import account from './account';

const dialogs = Object.assign({}, { toogle, freeze, account });
Object.keys(dialogs).forEach((key) => {
  if (!Vue.prototype.$_dialog) {
    Vue.prototype.$_dialog = {};
  }
  Vue.prototype.$_dialog[key] = dialogs[key];
});



// WEBPACK FOOTER //
// src/components/dialog/index.js